<template>
    <div>
        <a-card :bordered="false" class="header-solid" :bodyStyle="{paddingTop: 0 }" :headStyle="{paddingBottom: '0' }">
            <h6>Order Information - {{ restaurantName }}</h6>    
            <a-form-model>
                <a-row :gutter="[24]">
                    <a-descriptions bordered>
                        <a-descriptions-item label="Pickup Number">
                            {{ pickupNumber }}
                        </a-descriptions-item>
                        <a-descriptions-item label="Estimated time">
                            {{ estimatedTime }}
                        </a-descriptions-item>
                    </a-descriptions>
                </a-row>
                <br>
                <a-row :gutter="[24]">
                    <a-col :span="12">
                        <a-form-model-item class="mb-10"
                                label="Customer name"
                        >
                            <a-input v-model="customerName"/>
			            </a-form-model-item>
                    </a-col>

                    <a-col :span="12">
                        <a-form-model-item class="mb-10"
                                label="Phone"
                        >
                            <phone-input v-model="phoneNumber"/>
                            
			            </a-form-model-item>
                    </a-col>
                </a-row>

                <a-row :gutter="[24]">
                    <a-col :span="12">
                        <a-form-model-item class="mb-10"
                                label="Pickup time"
                        >
                            <a-time-picker format="HH:mm"
                                            :minuteStep="5"
                                            inputReadonly
                                            :disabledHours="getDisabledHours"
                                            hideDisabledOptions
                                            v-model="pickupTime"
                            />
			            </a-form-model-item>
                    </a-col>

                    <a-col :span="12">
                        <a-form-model-item class="mb-10">
                            <a-checkbox v-model="priority">
                                Priority
                            </a-checkbox>
                            <a-checkbox v-model="ASAP">
                                ASAP
                            </a-checkbox>
                        </a-form-model-item>
                    </a-col>

                </a-row>

                <a-row>
                    <a-col :span="12">
                        <a-form-model-item class="mb-10"
                                label="Comment"
                        >
                            <a-textarea :auto-size="{ minRows: 2, maxRows: 6 }" 
                                        allowClear 
                                        v-model="comment"
                            />
			            </a-form-model-item>
                    </a-col>
                </a-row>
            </a-form-model>
        </a-card>                        
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import PhoneInput from '../../components/inputs/PhoneInput.vue'

export default {
    components : {
        PhoneInput,
    },
    computed : {
        // ...mapState({
        //    currentWaitingTime : state => state.orderManager.currentWaitingTime,
        //    estimatedTime : state => state.ordering.estimatedTime,
        //    phoneNumber : state => state.ordering.phoneNumber,
        //    priority : state => state.ordering.priority,
        //    ASAP : state => state.ordering.ASAP,
        //    pickupNumber : state => state.ordering.pickupNumber,
        //    disabledHours : state => state.openingHours.disabledHours
        // }),
        ...mapState({
           currentWaitingTime : state => state.phoneService.orderManager.currentWaitingTime,
           phoneNumber : state => state.ordering.phoneNumber,
           priority : state => state.ordering.priority,
           ASAP : state => state.ordering.ASAP,
           pickupNumber : state => state.ordering.pickupNumber,
           disabledHours : state => state.openingHours.disabledHours,
           estimatedTime : state => state.ordering.estimatedTime
        }),
        ...mapGetters({
            restaurantName : 'phoneService/restaurantName',
            //estimatedTime : 'ordering/estimatedTime'
        }),
        
        customerName : {
            get() {
                return this.$store.state.ordering.customerName;
            },
            set(value) {
                this.$store.commit('ordering/CHANGE_CUSTOMER_NAME_STATE', value);
            }
        },
        phoneNumber : {
            get() {
                return this.$store.state.ordering.phoneNumber;
            },
            set(value) {
                console.log(value)
                let phone = value.replace(/\s/g, '');
                this.$store.commit('ordering/CHANGE_PHONE_NUMBER_STATE', phone);
            }
        },
        pickupTime : {
            get() {
                //return this.$store.getters['ordering/estimatedPickupTime'];
                return this.$store.state.ordering.pickupTime;
            },
            set(value) {
                this.$store.commit('ordering/CHANGE_PICKUP_TIME_STATE', value);
            }
        },
        priority : {
            get() {
                return this.$store.state.ordering.priority;
            },
            set(value) {
                this.$store.commit('ordering/CHANGE_PRIORITY_STATE', value);
            }
        },
        ASAP : {
            get() {
                return this.$store.state.ordering.ASAP;
            },
            set(value) {
                this.$store.commit('ordering/CHANGE_ASAP_STATE', value);
            }
        },
        comment : {
            get() {
                return this.$store.state.ordering.comment;
            },
            set(value) {
                this.$store.commit('ordering/CHANGE_COMMENT_STATE', value);
            }
        },
    },

    methods : {
       getDisabledHours() {
           return this.$store.state.openingHours.disabledHours;
       }
    }
}
</script>

<style>

</style>